import React from 'react';
import { useFormikContext } from 'formik';
import { Box, Grid, MenuItem, TextField, Typography } from '@material-ui/core';

type LinearScaleValues = {
  field: {
    minValue: number;
    maxValue: number;
    minLabel: string;
    maxLabel: string;
  };
};

const scaleOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const LinearScaleAdditionalFields = () => {
  const { values, setFieldValue } = useFormikContext<LinearScaleValues>();

  return (
    <Box>
      <Typography variant='body2' color='textSecondary' style={{ marginBottom: 8 }}>
        Scale Range
      </Typography>
      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        <Grid item xs={6}>
          <TextField
            select
            fullWidth
            variant='outlined'
            size='small'
            label='Min Value'
            value={values.field.minValue}
            onChange={(e) => setFieldValue('field.minValue', Number(e.target.value))}
          >
            {scaleOptions
              .filter((n) => n < values.field.maxValue)
              .map((n) => (
                <MenuItem key={n} value={n}>
                  {n}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            select
            fullWidth
            variant='outlined'
            size='small'
            label='Max Value'
            value={values.field.maxValue}
            onChange={(e) => setFieldValue('field.maxValue', Number(e.target.value))}
          >
            {scaleOptions
              .filter((n) => n > values.field.minValue)
              .map((n) => (
                <MenuItem key={n} value={n}>
                  {n}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
      </Grid>
      <Typography variant='body2' color='textSecondary' style={{ marginBottom: 8 }}>
        Labels (Optional)
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            variant='outlined'
            size='small'
            label='Min Label'
            placeholder='e.g. Not likely'
            value={values.field.minLabel}
            onChange={(e) => setFieldValue('field.minLabel', e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            variant='outlined'
            size='small'
            label='Max Label'
            placeholder='e.g. Very likely'
            value={values.field.maxLabel}
            onChange={(e) => setFieldValue('field.maxLabel', e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
